<template>
	<b-tooltip :target="refId" :show.sync="show" placement="bottom">{{ FormMSG(1, 'Some of timesheet details are out of contract.') }}</b-tooltip>
</template>
<script>
import LanguageMessages from '@/mixins/languageMessages';
import GlobalMixin from '@/mixins/global.mixin';
export default {
	name: 'WarningOutOfContractTooltip',
	mixins: [LanguageMessages, GlobalMixin],
	props: {
		refId: {
			type: String,
			required: true,
			default: null
		},
		show: {
			type: Boolean,
			required: true,
			default: false
		}
	}
};
</script>
<style lang="scss"></style>
